// Root-level actions that affect the entire application state

export const RESET_ALL_STATE = "RESET_ALL_STATE";

export interface ResetAllStateAction {
  type: typeof RESET_ALL_STATE;
}

export const resetAllState = (): ResetAllStateAction => ({
  type: RESET_ALL_STATE,
});
